/*
 * @Author: lishiqiao
 * @Date: 2022-01-19 11:48:49
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-01-20 09:52:57
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /**
     * @Author: lishiqiao
     * @Date: 2022-01-20 09:51:52
     * @description: 年度经营目标完成情况--查询顶级机构下的所有子机构
     * @param {*} rootId
     */
    getCompanyList(rootId) {
        const url = `/desktopReport/annualBusinessGoalsOrgFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-20 09:52:27
     * @description: 年度经营目标完成情况--查询顶级机构下的所有造次
     * @param {*} rootId
     */
    getPeriodList(rootId) {
        const url = `/desktopReport/annualBusinessGoalsPerioyFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-20 09:52:49
     * @description: 年度经营目标完成情况--查询顶级机构下的所有品种
     * @param {*} rootId
     */
    getBreedList(rootId) {
        const url = `/desktopReport/annualBusinessGoalsBreedFish/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 13:50:48
     * @description: 年度目标完成情况(汇总、明细)分页-(育苗、养成)
     * @param {*} params
     */
    getPageList(params) {
        const url = `/targetAnalysisOrg/searchTargetAnalysisOrgList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 13:52:27
     * @description: 年度目标完成情况（汇总、明细）表-（育苗、养成）导出
     * @param {*} params
     */
    exportData(params) {
        const url = `/targetAnalysisOrg/exportTargetAnalysisOrgList`;
        return Page.exportDatas(url, params)
    }
}